import { render } from "./CommonArticleList.vue?vue&type=template&id=7d4655c4"
import script from "./CommonArticleList.vue?vue&type=script&lang=js"
export * from "./CommonArticleList.vue?vue&type=script&lang=js"

import "./CommonArticleList.vue?vue&type=style&index=0&id=7d4655c4&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__